import {
	STEP_AGREEMENT,
	STEP_CLIENT,
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2,
	// STEP_INSURANCE,
	STEP_EP_REVIEW,
	// STEP_EP_TERM,
	STEP_EP_VEHICLE,
	STEP_PAYMENT,
	// STEP_SIGNATURE,
} from './constants';

export const forms = [
	STEP_EP_VEHICLE,
	// STEP_EP_TERM,
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2,
	STEP_PAYMENT,
	STEP_EP_REVIEW,
	STEP_AGREEMENT,
];

export const steps = [
	STEP_EP_VEHICLE,
	// STEP_INSURANCE,
	STEP_CLIENT,
	STEP_PAYMENT,
	STEP_EP_REVIEW,
];
